/**
 * Handles both select file 'input' and 'drag-and-drop' events for file uploads.
 *
 * @param {React.ChangeEvent<HTMLInputElement> | React.DragEvent<HTMLDivElement>} event - The event object (either file input or drag-and-drop).
 */
export const fileUpload = async (
  event: React.ChangeEvent<HTMLInputElement> | React.DragEvent<HTMLDivElement>,
  setValidationMsg,
  validationComplete,
  validateState,
  clearAll,
  setIsDragging,
) => {
  setValidationMsg(''); // Reset validation messages
  if (validationComplete) {
    //Resets files after validation is complete
    clearAll();
  }

  // If validation is in progress not possible to add files
  if (!validateState) {
    let selectedfiles;

    // Check if the event is a select file 'input'
    if ('target' in event && event.target instanceof HTMLInputElement) {
      const inputElement = event.target as HTMLInputElement;
      selectedfiles = inputElement.files;
      // Check if the event is a 'drag-and-drop' event
    } else if ('dataTransfer' in event) {
      event.preventDefault();
      const dragEvent = event as React.DragEvent<HTMLDivElement>;
      selectedfiles = dragEvent.dataTransfer.files;
      setIsDragging(false); // Reset dragging state on drop
    }

    return selectedfiles;
  }
};

//FIXME ADD VALIDATION METHOD TO SELECTED FILES
